import BasketStore from '../Stores/Basket';
import Config from '../Config';
import Helper from './Helper';
import Product from '../Stores/Product';
import Registry from '../Stores/Registry';
import {get} from 'svelte/store';

export default class Basket {
	products(data, product) {
		const basket = property => {
			if (Helper.is(property.selected.basket))
				for (let item of property.selected.basket)
					if (item.id) data[`basket_product[${item.id}]`] = item.count;
		};

		const upsell = property => {
			for (let item of property.selected.data)
				if (item.id) data[`basket_product[${item.id}]`] = item.count;
		};

		if (Array.isArray(product.steps))
			for (let step of product.steps)
				for (let property of step.properties)
					if (Helper.is(property.selected)) {
						basket(property);
						switch (property.property_type) {
							case 'upsells': upsell(property); break;
						}
					}

		return data;
	}

	department(product) {
		let department = 0;
		search:
			if (Array.isArray(product.steps))
				for (let step of product.steps)
					for (let property of step.properties)
						if (Helper.is(property.selected))
							if (Helper.iterable(property.selected.data))
								for (let item of property.selected.data)
									if (Helper.is(item.meta))
										if (item.meta.department) {
											department = item.meta.value;
											break search;
										}

		return department;
	}

	data() {
		const product = get(Product);
		const variation_id = product.variation.shop_group_product_id;

		let data = {};
		data = this.products(data, product);
		data['basket_parent'] = variation_id;
		data[`basket_product[${variation_id}]`] = 1;
		data['basket_department'] = this.department(product);
		data['basket_index'] = BasketStore.getIndex();
		data['skip_response'] = 1;
		return data;
	}

	async post() {
		const basket = this.data();
		console.info(basket);

		const data = new FormData();
		for (let field in basket)
			data.append(field, basket[field]);

		const url = Registry.shopUrl(Config.shop.basket);
		const config = {method: 'POST', body: data};
		const response = await fetch(url, config);
		return response.status == 200;
	}
}